/* eslint-disable prettier/prettier */
import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
    const data = isSuccessResponse(response)
    return data
}

const resolveIncident = (reqBody: any) => {
    const request: JFSRequest<{}> = {
        apiPath: getUrl(APIEndPoints.resolveIncident),
        method: 'POST',
        config: sitConfig(RootStore.session.getTokens),
        body: reqBody,
        headers: getHeaders(),
    }

    return executeRequest(request)
        .then((resp) => responseParser(resp))
        .catch((error) => {
            throw error
        })
}

export { resolveIncident }


